import { Component, HostListener, NgZone, OnInit } from '@angular/core';

@Component({
  selector: 'app-install-prompt',
  templateUrl: './install-prompt.component.html',
  styleUrls: ['./install-prompt.component.scss'],
})
export class InstallPromptComponent implements OnInit {
  showInstallPrompt = false;
  showIosInstallGuide = false;
  deferredPrompt: any = null;
  isIos = false;

  private readonly firstDelay = 10 * 1000; // 10 seconds
  private readonly promptDuration = 30 * 1000; // 30 seconds
  private readonly repeatInterval = 3 * 60 * 1000; // 3 minutes

  constructor(private ngZone: NgZone) {}

  ngOnInit(): void {
    setTimeout(() => this.checkIfStandalone(), 100);
    this.setupPromptTimer();
  }

  private setupPromptTimer(): void {
    setTimeout(() => {
      this.tryToShowPrompt();

      setInterval(() => {
        this.tryToShowPrompt();
      }, this.repeatInterval);
    }, this.firstDelay);
  }

  private tryToShowPrompt(): void {
    this.ngZone.run(() => {
      if (this.isIos && this.shouldShowIosGuide()) {
        this.showIosInstallGuide = true;
        this.autoHidePrompt('ios');
      } else if (this.deferredPrompt && navigator.onLine) {
        this.showInstallPrompt = true;
        this.autoHidePrompt('android');
      }
    });
  }

  private autoHidePrompt(type: 'ios' | 'android') {
    setTimeout(() => {
      if (type === 'ios') {
        this.showIosInstallGuide = false;
      } else {
        this.showInstallPrompt = false;
      }
    }, this.promptDuration);
  }

  private shouldShowIosGuide(): boolean {
    const isInStandaloneMode =
      ('standalone' in navigator && (navigator as any)['standalone']) ||
      window.matchMedia('(display-mode: standalone)').matches;

    return !isInStandaloneMode;
  }

  checkIfStandalone(): void {
    const userAgent = window.navigator.userAgent.toLowerCase();
    this.isIos = /iphone|ipad|ipod/.test(userAgent);
  }

  @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(event: Event) {
    event.preventDefault();
    this.deferredPrompt = event;
    console.log('Captured beforeinstallprompt event');
  }

  handleInstallClick(): void {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        this.deferredPrompt = null;
        this.showInstallPrompt = false;
      });
    }
  }

  handleDismissClick(): void {
    this.showInstallPrompt = false;
    this.showIosInstallGuide = false;
  }
}
